import React,  { Fragment } from 'react'
import { Avatar, Input, Button, Form, Icon } from '@drifthq/tide-core'
import { Link } from 'react-router-dom'
import DropZone from 'react-dropzone'

import './style.css'

import PreviewInput from 'components/PreviewInput'

const ProfileDetails = ({
  companyName,
  companyUrl,
  onCompanyNameChange,
  onCompanyUrlChange,
  onContinueClick,
  avatarUrl,
  name,
  onDrop,
  disabled
}) => {
  return (
    <Fragment>
      <h1>Where do you work?</h1>
      <p className="setup-description">
        Add your avatar and your company to let visitors know who they’re talking to.
      </p>
      <Form onSubmit={onContinueClick}>
        <PreviewInput
          label="Company"
          value={companyName}
          defaultOpen={companyName.length === 0}
          children
        >
          <Input
            className="profile-details-box profile-details-company-input"
            label="Company"
            placeholder="Drift"
            value={companyName}
            onChange={onCompanyNameChange}
          />
        </PreviewInput>
        <PreviewInput
          label="Company website"
          value={companyUrl}
          defaultOpen={companyUrl.length === 0}
          children
        >
          <Input
            className="profile-details-box profile-details-company-url-input"
            label="Company website"
            placeholder="www.yourcompany.com"
            value={companyUrl}
            onChange={onCompanyUrlChange}
          />
        </PreviewInput>
        <label>
          Your avatar
        </label>
        <DropZone
          className='profile-avatar'
          onDrop={onDrop}
        >
          <Avatar
            user={{ avatarUrl, name }}
            className="profile-avatar-img"
          />
          <div className="profile-avatar-description">
            Drag and Drop or <span className="profile-avatar-text">Choose a file</span> to upload
          </div>
        </DropZone>
        <div className="profile-next-step">
          <Button submit disabled={disabled}>
            Continue
          </Button>
          <div className="profile-nav">
            <Link
              className="profile-next"
              to="/setup/touchless/welcome"
            >
              <Icon name="arrow-1-left" className="profile-back-caret"/>
              Back
            </Link>
          </div>
        </div>
      </Form>
    </Fragment>
  )
}
export default ProfileDetails



// WEBPACK FOOTER //
// ./src/layouts/ProfileDetails/component.js